import React, { useMemo } from "react";
import DataTable from "../_Components/DataTable";
import _ from "lodash";
import Switch from "@mui/material/Switch";
import { Button } from "react-bootstrap";

function DataGrid({ data, setShowModalReserveItemGroup, setSelectedReserveItemGroupId, setShowModalAmusementsOrder }) {
  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 50,
      },
      {
        accessor: "title",
        Header: "عنوان",
        minWidth: 120,
      },
      {
        accessor: "amusementServiceName",
        Header: "تفریح",
        minWidth: 120,
      },
      {
        accessor: "reservationExpirationTime",
        Header: "ساعت اتمام فروش",
        minWidth: 120,
        Cell: ({ row }) => {
          const timeString = row.original.reservationExpirationTime;
          const formattedTime = timeString?.slice(0, 5); // Take only the first 5 characters (HH:mm)

          return <div className="text-center">{formattedTime}</div>;
        },
      },
      {
        Header: "وضعیت",
        minWidth: "100px",
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <Switch
              checked={row.original.isActive ? true : false}
              value="row.original.isActive"
              color="primary"
              inputProps={{ "aria-label": "primary checkbox" }}
            />
          </div>
        ),
      },

      {
        accessor: "createdPersianTime",
        Header: "زمان ایجاد",
        minWidth: 90,
        maxWidth: 90,
      },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            <Button
              title="ویرایش"
              className="btn btn-light-primary btn-sm mr-2 btn-icon"
              onClick={() => {
                setSelectedReserveItemGroupId(row.original.id);
                setShowModalReserveItemGroup(true);
              }}
            >
              <i className="far fa-edit text-small"></i>
            </Button>
          </div>
        ),
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
